// src\themes\lino\elements\Header\HeaderNavToggle.tsx
"use client";
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";
import { useDrawerStore } from "@/stores/drawerStore";

export default function HeaderNavToggle() {
  const { primaryOpen, setPrimaryOpen } = useDrawerStore();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => setPrimaryOpen(!primaryOpen)}
      aria-label={primaryOpen ? "Close menu" : "Open menu"}
      className="lg:hidden text-primary-900 hover:bg-primary-100 group-data-[transparent=true]:text-primary-0 group-data-[transparent=true]:hover:bg-primary-0/15 rounded-full"
    >
      <Menu className="w-5 h-5 stroke-[1.5]" />
    </Button>
  );
}
